// src/App.jsx
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { CssBaseline } from "@mui/material";

// VALMIKI AI LAB Pages
import ValmikiHome from "./Pages/ValmikiHome";
import ValmikiAbout from "./Pages/ValmikiAbout";
import ValmikiProgram from "./Pages/ValmikiProgram";
import ValmikiLab from "./Pages/ValmikiLab";
import ValmikiFounder360 from "./Pages/ValmikiFounder360 ";
import ValmikiPartner from "./Pages/ValmikiPartner";
import ValmikiContact from "./Pages/ValmikiContact";

// Navbar + shared route map
import ValmikiNavbar, { VALMIKI_ROUTES } from "./Pages/ValmikiNavbar";

import "./App.css";

function App() {
  return (
    <Provider store={store}>
      <CssBaseline />
      <Router>
        {/* Navbar rendered ONCE at the top — persists across all routes */}
        <ValmikiNavbar />

        <div className="app-container">
          <main className="main-content">
            <Routes>
              <Route path={VALMIKI_ROUTES.home} element={<ValmikiHome />} />
              <Route path={VALMIKI_ROUTES.about} element={<ValmikiAbout />} />
              <Route path={VALMIKI_ROUTES.program} element={<ValmikiProgram />} />
              <Route path={VALMIKI_ROUTES.lab} element={<ValmikiLab />} />
              <Route path={VALMIKI_ROUTES.founder360} element={<ValmikiFounder360 />} />
              <Route path={VALMIKI_ROUTES.partner} element={<ValmikiPartner />} />
              <Route path={VALMIKI_ROUTES.contact} element={<ValmikiContact />} />

              {/* Catch-all → redirect unknown URLs home */}
              <Route path="*" element={<Navigate to={VALMIKI_ROUTES.home} replace />} />
            </Routes>
          </main>
        </div>
      </Router>
    </Provider>
  );
}

export default App;